import apiClient from "@/services";

const getProduct = async (type, id) => {
  try {
    const { status, data } = await apiClient.get(`/getRequest?type=${type}&id=${id}`);

    if (status === 200) {
      return data;
    } else {
      throw new Error(`Unexpected response status: ${status}`);
    }
  } catch (error) {
    console.error("Error fetching products:", error.message || error);
    return [];
  }
};

export default getProduct;
